// @flow
import { thunkProgress } from 'redux-progress';
import hamsClient from 'modules/hams';
import { PLACE_ORDER } from 'modules/checkout/review/duck/actions/submit';
import type { Dispatch, GetState } from 'model/State';
import { selectHamsClientConfig } from 'modules/auth/selectors';
import type { accountPayload } from 'modules/checkout/review/duck/model';
import { addUpdatedTimeStamp } from 'modules/checkout/review/duck/util';
import type { CheckoutType } from './submit';

// eslint-disable-next-line max-len
export default (cartId: string, checkoutType: CheckoutType) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const data: accountPayload = addUpdatedTimeStamp({ authenticated: true }, state);
    return dispatch(
      thunkProgress(
        PLACE_ORDER,
        hamsClient
          .post(
            `/1.0/public/order/cart/${cartId}/processPayOnAccountOrder`,
            data,
            selectHamsClientConfig(state),
          )
          .then((r) => r),
        { checkoutType },
      ),
    );
  };
